import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { Button } from '@mui/material'

import { useModifyPasswordMutation } from '@/core/services/auth'

import ChangePasswordDialog, { ChangePasswordFormValues } from '../components/ChangePasswordDialog'

export default function ChangePasswordDialogContainer() {
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const [open, setOpen] = useState(false)

  const [modifyPassword, { isLoading }] = useModifyPasswordMutation()

  const handleModifyPassword = async (values: ChangePasswordFormValues) => {
    try {
      await modifyPassword(values.password)
      setOpen(false)
      enqueueSnackbar(t('notification.authUser.updatePassword.success'), { variant: 'success' })
    } catch (error) {
      enqueueSnackbar(t('notification.authUser.updatePassword.error'), { variant: 'error' })
    }
  }

  return (
    <>
      <Button color="primary" disableElevation onClick={() => setOpen(true)} variant="contained">
        {t('page.configuration.changePasswordButton.label')}
      </Button>
      <ChangePasswordDialog isSubmitting={isLoading} onClose={() => setOpen(false)} onSubmit={handleModifyPassword} open={open} />
    </>
  )
}
